import { flashFeed } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FlashFeed() {
  return (
    <section id="flash" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <SectionHeading
              label="Daily Flashes"
              title="今日热瓜速报"
              desc="按时间倒序滚动更新，黑料网吃瓜速览把刚冒头的现场与回应先放到最前面，刷起来不费劲。"
            />
            <span className="inline-flex items-center gap-2 text-sm text-foreground-500 whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              实时更新中
            </span>
          </div>

          <div className="mt-8 md:mt-10 border-t border-background-200">
            {flashFeed.map((item) => (
              <a
                key={item.title}
                href="#covers"
                className="group grid grid-cols-[auto_1fr] md:grid-cols-[80px_1fr_auto] items-start md:items-center gap-x-4 md:gap-x-6 gap-y-2 py-4 md:py-5 px-2 md:px-4 border-b border-background-200 rounded-md cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm text-foreground-500 tabular-nums pt-0.5 md:pt-0">{item.time}</span>
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 min-w-0">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </span>
                </div>
                <div className="col-span-2 md:col-span-1 flex items-center gap-4 text-foreground-500 md:justify-end">
                  <span className="text-xs whitespace-nowrap inline-flex items-center gap-1">
                    <i className="ri-fire-line text-accent-600"></i>
                    {item.heat}
                  </span>
                  <i className="ri-arrow-right-line hidden md:inline text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}